import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../residue_dashboard/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_RESIDUE_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

export const getGuidesInfoByCategory = id => apiClient.get(url.RESIDUE_DASHBOARD_INFO_CATEGORY + '/' + id);
export const getGuidesInfoByType = id => apiClient.get(url.RESIDUE_DASHBOARD_INFO_TYPE + '/' + id);
export const getGuidesInfoByStatus = id => apiClient.get(url.RESIDUE_DASHBOARD_INFO_STATUS + '/' + id);
export const getGuidesInfoByEstablishmenteType = () => apiClient.get(url.RESIDUE_DASHBOARD_INFO_ESTABLISHMENTE_TYPE);
export const getCategoryByYear = () => apiClient.get(url.RESIDUE_DASHBOARD_CATEGORY_BY_YEAR);
export const getResidueManagement = () => apiClient.get(url.RESIDUE_DASHBOARD_MANAGEMENT);


export const getGuidesInfoCompareType = id => apiClient.get(url.RESIDUE_DASHBOARD_COMPARE_TYPE+ '/' + id);
export const getGuidesInfoCompareStatus = id => apiClient.get(url.RESIDUE_DASHBOARD_COMPARE_STATUS+ '/' + id);
export const getGuidesInfoCompareManagement = id => apiClient.get(url.RESIDUE_DASHBOARD_COMPARE_MANAGEMENT+ '/' + id);
export const getGuidesInfoByFinalDestination = () => apiClient.get(url.RESIDUE_DASHBOARD_FINAL_DESTINATION);

export const getPointEstablishmentResidue = () => apiClient.get(url.RESIDUE_DASHBOARD_MAP_POINTS);
